import React from "react";
import ACCENT_SECTION_STYLE from "./accentSectionStyle";

const AboutUsSection = () => (
  <section
    className="faqs"
    id="about-us"
    aria-labelledby="about-us-title"
    style={ACCENT_SECTION_STYLE}
  >
    <div className="container">
      <div className="section-head">
        <span className="section-num">06</span>
        <h2 className="section-title" id="about-us-title">
          About <em>42courses</em>.
        </h2>
      </div>

      <div className="faq-list">
        <details className="faq-item">
          <summary>Who founded 42courses?</summary>
          <div className="faq-answer">
            <p>
              <strong>Chris Rawlinson</strong>, former innovation leader at
              Ogilvy and WPP.{" "}
              <em>Fun fact: also holds a commercial pilot's licence.</em>
            </p>
            <p>
              <strong>Jake Courage</strong>, former global marketing strategist.{" "}
              <em>
                Fun fact: arguably the coolest name in the world. The fictional
                photographer in the Halo campaigns was named after him.
              </em>
            </p>
            <p>
              The platform launched in 2016.{" "}
              <a href="/about_us">Read the full story.</a>
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Why is the company called 42courses?</summary>
          <div className="faq-answer">
            <p>
              Because{" "}
              <strong>
                42 is the Answer to the Ultimate Question of Life, the Universe,
                and Everything
              </strong>
              , courtesy of Douglas Adams. Chris picked the name in a Cape Town
              bar in 2014 after every sensible domain name he liked was taken.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Where are you based?</summary>
          <div className="faq-answer">
            <p>
              Our team is scattered across the UK, USA, Europe, South Africa and
              Canada. Our learners are in 170+ countries, so it would feel a bit
              odd to pretend we were tied to one office.
            </p>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default AboutUsSection;
